/* 
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved. */

import { Polymer, html } from '@polymer/polymer/polymer-legacy.js';
import './app-paper-input.js';
import '../../oe-ui-misc/oe-hbox.js'
import '../../oe-ui-misc/oe-vbox.js'
import '../../speedboat_ui/behaviors/keyboard-accessibility.js';
import "../../sb_Registration_ui/behaviors/online-registration.js";
import './app-paper-input-custom.js';
const template = html` <style include="login-styles mdl-grid-css">
.stealthy {
    left: 0;
    margin: 0;
    max-height: 1px;
    max-width: 1px;
    opacity: 0;
    outline: none;
    overflow: hidden;
    pointer-events: none;
    position: absolute;
    top: 0;
    z-index: -1;
}

:dir(rtl) .stealthy {
    left: auto;
	right: 0;
    margin: 0;
    max-height: 1px;
    max-width: 1px;
    opacity: 0;
    outline: none;
    overflow: hidden;
    pointer-events: none;
    position: absolute;
    top: 0;
    z-index: -1;
}

.otp-messge {
    @apply --message-style;
}

app-paper-input {
    --border-color: var(--app-border-color);
    /*--font-color: var(--app-font-color); */
}

.font-styling {
    @apply --font-style;
}
.main-container{
	margin:-35px 0px 0px 0;
}

/* MB style */
@media (max-width: 479px){
    .mb-width{
        width: 100%;
        }
        .main-container{
            margin:0px 0px 0px 0px;
        }
}
</style>
<app-media-query phone="{{phone}}" tablet="{{tablet}}" desktop="{{desktop}}"></app-media-query>
<oe-ajax id="generate_auth_otp_ajax" method="post" handle-as="json" content-type="application/json" url="/api/authenticationOTPGeneration"
on-response="resendOTPresponse" on-error="showError"></oe-ajax>
<div class="main-container margin-t-zero mb-width">
        <oe-hbox class="layout center-justified mb-width" style="padding:10px;">
            <!--Added app-paper-input-->
            <!--<app-paper-input id="fin_auth_otp_app_input" required="{{required}}" phone="{{phone}}" tablet="{{tablet}}" desktop="{{desktop}}" isvalid="{{isvalid}}"
                inputlength=[[otplength]] value="{{otpvalue}}" finalvalue="{{finalvalue}}" isdisabled="{{isdisabled}}" role="group"
                aria-label$="{{getLabel('l_OtpValidationMsg')}}"></app-paper-input>-->

                <app-paper-input-custom id="fin_auth_otp_app_input" required="{{required}}" phone="{{phone}}" tablet="{{tablet}}" desktop="{{desktop}}" isvalid="{{isvalid}}"
                inputlength=[[otplength]] value="{{otpvalue}}" finalvalue="{{finalvalue}}" isdisabled="{{isdisabled}}" role="group"
                aria-label$="{{getLabel('l_OtpValidationMsg')}}"></app-paper-input-custom>
        </oe-hbox>
         

</div>
		 
		`;


Polymer({
    is: 'fin-auth-softtoken-otp',
    behaviors: [accessibilityBehaviours.commonFunctions, sbBehaviours.onlineRegistration],
    _template: template,
    properties: {
        otpLink: {
            type: Boolean,
            notify: true
        },
        resendUrl: {
            type: String,
            value: ''
        },
        wrapperValue: {
            type: String,
            value: '',
            notify: true
        },
        wrapperValueInput: {
            type: String,
            value: '',
            notify: true,
            observer: 'inputValueChanged'
        },
        finalvalue: {
            type: String,
            notify: true,
            observer: 'finalValueChange'
        },
        /* If the String is valid or not by length. This should be used by parent element to check before Submit*/
        isvalid: {
            type: Boolean,
            notify: true,
        },
        /* mobile number of user*/
        mobilenumber: {
            type: Number,
            notify: true
        },
        otpvalue: {
            type: String,
            notify: true,
            value: ''
        },
        /*Length of the OTP*/
        otplength: {
            type: Number,
            notify: true
        },
        userDetails: {
            type: Object,
            notify: true
        },
        /*flag to hide the status message*/
        hideSpinner: {
            type: Boolean,
            notify: true,
            value: true
        },
        /*flag to disable the button and input*/
        isdisabled: {
            type: Boolean,
            notify: true,
            value: false
        },
        /*corporate Id of the user, this is used in non logged in as the context is not created yet*/
        corpId: {
            type: String,
            notify: true,
            value: ''
        },
        /*user id, this is used in non logged in as the context is not created yet*/
        userId: {
            type: String,
            notify: true,
            value: ''
        },
        required: {
            type: Boolean,
            notify: true
        },
		userName: {
			type: String,
			notify: true,
            observer:'check'
		}
    },
    inputValueChanged: function () {
        var self = this;
        if (self.wrapperValueInput) {
            self.wrapperValue = sbEncrypt.encrypt(self.wrapperValueInput);
        }
    },
    finalValueChange: function () {
        //Parent element is expecting value and encrypted value 
        var self = this;
        // Checking if the String length is as per given length
        if (this.otplength) {
            if (this.otplength == self.finalvalue.length) {
                self.isvalid = true;
                self.wrapperValue = sbEncrypt.encrypt(self.finalvalue);
                self.wrapperValueInput = self.finalvalue;
                self.fire("stknotpValue", {data:self.wrapperValue});
                window.dispatchEvent(new CustomEvent('clearOtp', {
                })); 
            } else {
                self.isvalid = false;
                self.wrapperValue = "";
                self.wrapperValueInput = "";
            }

        } else {
            //OTP length is not set
        }

    },
    ready: function () {
        var userid=clientStorage.get(storageType.session, 'userId');
        //Ajax call to get mobile number
        var self = this;
        var ajaxCall = document.createElement('oe-ajax');
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";
        //ajaxCall.url = '/api/CBUsers/' + clientStorage.get(storageType.session, 'userId');
        ajaxCall.url = '/api/CBUsers/' + "NBBCORP.PALANI";
        ajaxCall.method = 'get';
        ajaxCall.addEventListener('response', function (event) {
            self.mobilenumber = event.detail.response.userDetail.userPhoneNumber;
        });

        ajaxCall.addEventListener('error', function () {
            //Unable to get Mobile Number
            self.mobilenumber = ".";
        });
    /*    if (clientStorage.get(storageType.session, 'userId') != 'undefined' && clientStorage.get(storageType.session, 'userId') != null) {
            oeAjaxEventListner(ajaxCall);
            ajaxCall.generateRequest();
        }
     */   
        //get length of otp from config
        if (config.SpeedBoat.App.otp) {
            this.otplength = config.SpeedBoat.App.otp.lengthOfOtp;
        }
        //try to read SMS when element is loaded.
        this.readSMS();
    },
    attached: function () {
       // this.$$("#fmpwd2").value = "dummy";
        //this.$$("#pwd1").value = "dummy";
    },
    readSMS: function () {
        //sms variable plugin is for requesting permission
        var self = this;
        var permissions;
        if ((/(android)/i.test(navigator.userAgent))) {
            //Check if plugins are installed or not
            if ((typeof cordova !== "undefined") || (typeof SMS !== "undefined")) {
                //Assign permissions to variable.
                //permissions variable will have READ_SMS,WRITE_SMS value
                permissions = cordova.plugins.permissions;
                document.addEventListener('deviceready', initApp, false);
            } else {
                //Plugins not available
            }
        }

        function initApp() {
            //Chech whether permission is there for reading sms
            permissions.hasPermission(permissions.READ_SMS, permissionSuccess, permissionError);

            //Success callback on hasPermission
            function permissionSuccess(status) {
                if (status.hasPermission) {
                    //Disabling input just before starting spinner
                    self.isdisabled = true;
                    //Start Spinner if you have permission
                    startSpinner();
                    //Has read sms permission so add OnSMSArrive event
                    addOnSMSArriveEvent();
                } else {
                    //Requesting permission for reading sms
                    permissions.requestPermission(
                        permissions.READ_SMS,
                        requestPermissionSuccess,
                        requestPermissionError);

                    //Success callback on requestPermission
                    /* eslint-disable-next-line */
                    function requestPermissionSuccess(result) {
                        if (!result.hasPermission) {
                            requestPermissionError();
                        } else {
                            self.isdisabled = true;
                            //Start Spinner if you have permission
                            startSpinner();
                            //Has read sms permission so add OnSMSArrive event                                    
                            addOnSMSArriveEvent();
                        }
                    }
                    //Error callback on requestPermission
                    /* eslint-disable-next-line */
                    function requestPermissionError() {

                    }
                }
            }
            //Error callback on hasPermission
            function permissionError() {
                //Something went wrong in checking sms permission:' + e
            }

            //Add OnSMSArrive Event
            function addOnSMSArriveEvent() {
                document.addEventListener("onSMSArrive", function (e) {
                    if (e.data.body != undefined) {
                        var response;
                        var otp = extractOTPFromMsg(e.data.body);
                        if (otp.length == config.SpeedBoat.App.otp.lengthOfOtp) {
                            response = e.data;
                            //Compare sender message
                            // self.$.finAuthOtp_spinner.alt = "Reading";
                            if (response.body && (config.SpeedBoat.App.otp != undefined)) {
                                if (response.body.indexOf(config.SpeedBoat.App.otp.otpMessage) >= 0) {
                                    //Enabling input once SMS is received.
                                    self.isdisabled = false;
                                    self.otpvalue = otp;
                                    self.$.finAuthOtp_spinner.active = false;
                                    self.hideSpinner = true;
                                    SMS.stopWatch(stopWatchSuccess, stopWatchError);
                                } else {
                                    //Invalid message read
                                }
                            } else {
                                //else response
                            }
                        }
                    }

                });

                SMS.startWatch(startWatchSuccess, startWatchError);
            }

            function extractOTPFromMsg(msg) {
                var replacedMsg = msg.replace(/\s/g, '');
                //Regex for "Your one time password OTP is 676533""
                var validMsg1 = /(\()*(OTP)+(\))*(is)*[0-9]+/ig;
                //Regex for "565252 is the One time Password (OTP)""
                var validMsg2 = /[0-9]+(is)+[a-zA-Z0-9_]*(\()*(\))*(OTP)/ig;

                if (validMsg1.test(replacedMsg)) {
                    var validOTP = replacedMsg.match(validMsg1).toString().match(/[0-9]+/g).toString();
                    return validOTP;
                } else if (validMsg2.test(replacedMsg)) {
                    validOTP = replacedMsg.match(validMsg2).toString().match(/[0-9]+/g).toString();
                    return validOTP;
                } else {
                    //No Condition matched for available regular expression
                }


            }
        }

        function startWatchSuccess() {
            //startWatchSuccess
        }

        function startWatchError() {
            //startWatchFailure
        }

        function stopWatchSuccess() {
            //while removing the event, we should pass only event name without "on".
            //stopWatchSuccess
        }

        function stopWatchError() {
            //stopWatchError
        }
        /*function to start Spinner*/
        function startSpinner() {
            //Making the Spinner active and setting the status
            //var spinerElement = document.getElementById('finAuthOtp_spinner');

            self.$.finAuthOtp_spinner.active = true;
            self.hideSpinner = false;

            //Getting the Exprity from configuration and if not found waiting for 10 second.
            var OtpExptiryTime;
            if (config.SpeedBoat.App.otp.otpExpTime) {
                OtpExptiryTime = config.SpeedBoat.App.otp.otpExpTime;
                OtpExptiryTime = OtpExptiryTime * 1000;
            } else {
                OtpExptiryTime = 10000;
            }

            setTimeout(function () {
                self.$.finAuthOtp_spinner.active = false;
                self.hideSpinner = true;
                self.isdisabled = false;
            }, OtpExptiryTime);


        }


        //  }

    },
    _closeDialog: function () {
      var e =this.$$('iron-overlay-backdrop');
      e.className="closed";
        this.$.resendOTPdialog.$$("#resendOTPdialog").close();
    },
    _auth_otp_resend: function () {
        this.$.resendOTPdialog.$$("#resendOTPdialog").open();
    },
    /*function to resend the OTP*/
    _auth_otp_resend_invoke_call: function () {

        var flag = confirm("Do you want to resend OTP?\n");
        if (flag) {
            this.wrapperValueInput = "";
            //otpvalue can not be understand the change when its blank

            if (this.otpvalue === ' ') {
                this.otpvalue = '1';  //This is to call obeserver in app-paper-input and only string should be passed
            }
            else {
                this.otpvalue = ' ';
            }
            //  attach ajax calls to support this functionality
            if (this.resendUrl == 'authentication') {
                if (this.userId && this.corpId) {
                    this.$.generate_auth_otp_ajax.body = {
                        "userId": this.userId,
                        "corpId": this.corpId
                    };
                }
                else if (this.userId) {
                    this.$.generate_auth_otp_ajax.body = {
                        "userId": this.userId
                    };
                }
                if (this.is_cust_assist) {
                    this.$.generate_auth_otp_ajax.body["is_cust_assist"] = this.is_cust_assist;
                    this.$.generate_auth_otp_ajax.body["requested_by"] = this.requested_by;
                    this.$.generate_auth_otp_ajax.body["access_token"] = this.access_token;
                }
                this.$.generate_auth_otp_ajax.url = "/api/authenticationOTPGeneration";
                this.$.generate_auth_otp_ajax.generateRequest();
            }// start of changes made for enabling resend otp button for transaction flows
            else if (this.resendUrl == 'authorization') {
                if (this.userId && this.corpId) {
                    this.$.generate_auth_otp_ajax.body = {
                        "userId": this.userId,
                        "corpId": this.corpId
                    };
                } else if (this.userId) {
                    this.$.generate_auth_otp_ajax.body = {
                        "userId": this.userId
                    };
                }
                this.$.generate_auth_otp_ajax.url = "/api/authorizationOTPGeneration";
                this.$.generate_auth_otp_ajax.generateRequest();
            }
            //end of changes made for enabling resend otp button for transaction flows
            else if (this.resendUrl == 'nonLoggedIn') {
                /* deleting this fields from userDetails object as retailusers-onboarding-resend-otp api does not accept these fields*/
                delete this.userDetails.userDetail.middleName;
                delete this.userDetails.userDetail.gender;
                delete this.userDetails.userDetail.aadharNumber;
                delete this.userDetails.userDetail.dLNumber;
                delete this.userDetails.userDetail.panNumber;
                delete this.userDetails.userDetail.ekycFlag;
                var tempObj = {
                    data: this.userDetails.userDetail
                };
                delete tempObj.data.salutation;
                delete tempObj.data.securePin;
                //delete tempObj.data.authenticationDetais;
                //console.log("tempObj finauthOtp" + JSON.stringify(tempObj));
                tempObj = document.getElementById('keyManagement').setSymKey(tempObj);
                tempObj.data = sbEncrypt.encrypt(JSON.stringify(tempObj.data));


                this.submitDetails("/api/Banks/retailusers-onboarding-resend-otp", "post", tempObj, this.header);
            }
            else {
                //TODO: to be done for authorization 
                alert(getLabel('m_YourOTPSent'));
            }
            // }
            this.readSMS();
            this.isvalid = false;
        }
        var e =this.$$('iron-overlay-backdrop');
        e.className="closed";
    },
    _callSucessPage: function (e) {
        var responseHeader = JSON.parse(e.detail.xhr.getResponseHeader('channelcontext'));
        var successobj = {}
        successobj.response = e.detail.response;
        successobj.chennelContext = responseHeader;
        var message = successobj.chennelContext.status.message[0].messageDesc;
        this.fire('oe-show-success', message);
    },
    showError: function (event) {
        showAjaxError(event);
    },
    resendOTPresponse: function () {
        this.fire('oe-show-success', getLabel("m_PhoneNumberVerificationOTPMessage"));
    } 
});
